import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Radio from './Radio'

const RadioList = ({ list = [{label:"Yes", value: "Y"}, {label:"No", value: "N"}], text, name, value, disabled, onChange, required=false }) => {
  const className = required ? "text-grey font-weight-bold medium required" : "text-grey font-weight-bold medium";
  return (
    <Row >
      <Col>
        <Row>
          <Col className={className}>{text}</Col>
        </Row>
        <Row className="ml-1 my-2 pt-1">
          <Col>
            {list.map((obj, index) => {
              return <Radio to={text} 
                      name={name} 
                      label={obj.label}
                      value={obj.value}
                      checked={obj.value===value} 
                      key={index} 
                      onChange={onChange} disabled={disabled || obj.disabled}
                      required={required}/>
            })}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default RadioList
